import React, {useState} from "react";
import {Spinner} from "react-bootstrap";
import CheckBoxBlankIcon from "./CheckBoxBlankIcon";
import CheckBoxSelectedIcon from "./CheckBoxSelectedIcon";
import UgyWarningTextBox from "../ugy/UgyWarningTextBox";

const planContents = (oneMonthDto,
                      threeMonthDto,
                      sixMonthDto,
                      oneYearDto) => {
    return [
        {
            id: 1,
            header: "1 Aylık",
            enumValue: "PRESALE_MONTH",
            price: oneMonthDto.totalBill,
            discountPrice: oneMonthDto.discountedTotalBill,
            features: [""],
            outline: true,
            discount: ''
        },
        {
            id: 2,
            header: "3 Aylık",
            enumValue: "PRESALE_QUARTER",
            price: threeMonthDto.totalBill,
            discountPrice: threeMonthDto.discountedTotalBill,
            features: [""],
            outline: true,
            discount: `%${threeMonthDto?.discountRate} İndirim`
        },
        {
            id: 3,
            header: "6 Aylık",
            enumValue: "PRESALE_HALF",
            price: sixMonthDto.totalBill,
            discountPrice: sixMonthDto.discountedTotalBill,
            features: [""],
            outline: true,
            discount: `%${sixMonthDto?.discountRate} İndirim`
        },
        {
            id: 4,
            header: "1 Yıllık",
            enumValue: "PRESALE_YEAR",
            price: oneYearDto.totalBill,
            discountPrice: oneYearDto.discountedTotalBill,
            features: [""],
            outline: true,
            discount: `%${oneYearDto?.discountRate} İndirim`
        },
    ]
};

const UgyPlan = (props) => {

    const [hovered, setHovered] = useState(false);

    const hoverStyles = {
        transition: 'transform 0.3s',
        cursor: 'pointer'
    };

    const handleHover = () => {
        setHovered(true);
    };

    const handleMouseLeave = () => {
        setHovered(false);
    };

    return (
        <div
            style={{...hoverStyles, ...(hovered && {transform: 'scale(1.09)'})}}
            onMouseEnter={handleHover}
            onMouseLeave={handleMouseLeave}
            onClick={() => {
                if (props.selectedBillingDto) {
                    return
                }
                props.setSelectedEnumValue(props.enumValue);
            }}
            className={
                props?.selectedEnumValue !== props.enumValue
                    ? "card mb-4 shadow mb-5 bg-white rounded"
                    : "card mb-4 shadow mb-5 bg-red rounded card-selected"
            }
        >

            <div
                className="card-header card-header-color d-flex align-items-center justify-content-between"
                style={{
                    color: props?.selectedEnumValue !== props.enumValue ? "black" : "black",
                    backgroundColor:
                        props?.selectedEnumValue !== props.enumValue ? "rgba(0,0,0,.05)" : "darkblue",
                }}
            >
                <h5 className="my-0 font-weight-bold text-center" style={{width: "100%"}}>{props.header}</h5>
                {props.enableCheckBoxIcon && !(props.selectedBillingDto && props?.selectedEnumValue !== props.enumValue) ? <div id="checkboxDiv">
                    {props?.selectedEnumValue !== props.enumValue ? <CheckBoxBlankIcon/> : <CheckBoxSelectedIcon/>}
                </div> : <></>}
            </div>
            <div className="card-body">
                {props.discount === '' ? <br/> : <h4 className="card-title pricing-card-title"
                                                   style={{textDecoration: "line-through"}}>{`${props?.price.toLocaleString("en-US")} TL`}</h4>}
                <h4 className="card-title pricing-card-title card-title-color">{`${props?.discountPrice.toLocaleString("en-US")} TL`}</h4>
            </div>
            <div className="card-footer"
                 style={{
                     color: props?.selectedEnumValue !== props.enumValue ? "red" : "white",
                     backgroundColor:
                         props?.selectedEnumValue !== props.enumValue ? "rgba(0,0,0,.05)" : "darkblue",
                 }}
            >
                {props.discount === '' ? <br/> : <h5 className="my-0 font-weight-bold">{`${props.discount}`}</h5>}
            </div>
        </div>
    );
};

const UgyPlansYearly = (props) => {

    if (!props.ugyDto) {
        return <Spinner size="lg" animation="border" role="status">
            <span className="sr-only">Loading...</span>
        </Spinner>;
    }

    const ugyPlanData = planContents(
        props?.ugyDto?.oneMonthDto,
        props?.ugyDto?.threeMonthDto,
        props?.ugyDto?.sixMonthDto,
        props?.ugyDto?.oneYearDto
    );

    const plans = ugyPlanData.map((obj, i) => {
        return (<>
                <UgyPlan
                    key={obj.header}
                    header={obj.header}
                    price={obj.price}
                    discountPrice={obj.discountPrice}
                    features={obj.features}
                    outline={obj.outline}
                    id={obj.id}
                    enumValue={obj.enumValue}
                    selectedEnumValue={props.selectedEnumValue}
                    setSelectedEnumValue={props.setSelectedEnumValue}
                    enableCheckBoxIcon={props.enableCheckBoxIcon}
                    selectedBillingDto={props.selectedBillingDto}
                    discount={obj.discount}
                />
            </>
        );
    });

    return <>
        <div className="card-deck mb-1 text-center">
            {plans}
        </div>
        <div>
            <UgyWarningTextBox/>
        </div>
    </>;
}

export default UgyPlansYearly;